export default "__VITE_ASSET__Dn0mDp7H__"